<script>
  import { onMount } from "svelte";
  import { MDCDialog } from '@material/dialog';


  // component options  ------------------------------------------------------ //

  export let id;
  export let title;
  export let content;
  export let buttons;
  export let open_on_load = false;
  export let modal = false;


  // internal variables ------------------------------------------------------ //

  let dialog;


  // utility functions -------------------------------------------------------- //

  const init_dialog = () => {
    dialog = new MDCDialog(document.querySelector(`#${id}`));

    if (modal === true) {
      dialog.scrimClickAction = '';
      dialog.escapeKeyAction = '';
    }

    if (open_on_load === true) dialog.open();
  };

  export const open = () => {
    if (modal === true) {
      dialog.scrimClickAction = '';
      dialog.escapeKeyAction = '';
    }

    if(!!dialog) dialog.open();
  };

  export const close = () => dialog.close();

  onMount(() => {
    init_dialog();
  })
</script>


<style>
  .mdc-dialog {
    text-align: center;
  }

  .mdc-dialog__content {
    font-family: Roboto, sans-serif;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    font-size: 1rem;
    line-height: 1.5rem;
    font-weight: 400;
    letter-spacing: .03125em;
    text-decoration: inherit;
    text-transform: inherit;
    flex-grow: 1;
    box-sizing: border-box;
    margin: 0;
    padding: 20px 24px;
    padding-top: 20px;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
  }

  .mdc-dialog__title {
    font-family: Roboto, sans-serif;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    font-size: 1.25rem;
    line-height: 2rem;
    font-weight: 500;
    letter-spacing: .0125em;
    text-decoration: inherit;
    text-transform: inherit;
    display: block;
    position: relative;
    flex-shrink: 0;
    box-sizing: border-box;
    margin: 0;
    padding: 0 24px 9px;
    border-bottom: 1px solid transparent;
  }

  .mdc-dialog__actions {
    display: flex;
    position: relative;
    flex-shrink: 0;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end;
    box-sizing: border-box;
    min-height: 52px;
    margin: 0;
    padding: 8px;
    border-top: 1px solid transparent;
  }

  .mdc-button {
    margin: 1em;
  }

  .btn-worker, btn-worker:hover {
    background-color: var(--worker-background-color);
    color: var(--orderer-foreground-color);
  }

  .btn-orderer, btn-orderer:hover {
    background-color: var(--orderer-background-color);
    color: var(--orderer-foreground-color);
  }

  /* Mobile Mode
  *******************************************************/

  @media (min-height: 0) and (max-height: 735px) {
      #first-time-role-selector-dialog {
          margin-top: -70px;
      }
  }
</style>


<svelte:options accessors={true}></svelte:options>


<div id={id} class="mdc-dialog">
  <div class="mdc-dialog__container">
    <div class="mdc-dialog__surface"
         role="alertdialog"
         id={`dialog-surface-${id}`}
         aria-modal="true"
         aria-labelledby="my-dialog-title"
         aria-describedby="my-dialog-content">

      <!-- Title cannot contain leading whitespace due to mdc-typography-baseline-top() -->
      <h2 class="mdc-dialog__title"
          id="my-dialog-title">
          {title}
      </h2>

      <div class="mdc-dialog__content"
           id="my-dialog-content">
          {@html content}
      </div>

      <footer class="mdc-dialog__actions">
          {#each buttons as button}
            {#if button.id}
              <button id="{button.id}" class="mdc-button mdc-button--raised {button.classes}"
                      tabindex="0"
                      disabled={!!button.wait_api}
                      on:click|preventDefault|stopPropagation={button.action}>
                  {button.label}
              </button>
            {:else}
              <button class="mdc-button mdc-button--raised {button.classes}"
                      tabindex="0"
                      disabled={!!button.wait_api}
                      on:click|preventDefault|stopPropagation={button.action}>
                {button.label}
              </button>
            {/if}
          {/each}
      </footer>
    </div>
  </div>

  <div class="mdc-dialog__scrim"></div>
</div>
